import axios from 'axios';
import {
    FedExRegistrationStatusResponse,
    FedExFactor1Request,
    FedExRequestPinRequest,
    FedExSubmitPinRequest,
    FedExSubmitInvoiceRequest,
    FedExEscalateSupportRequest,
    FedExRotateCredentialsRequest,
} from '@/models/FedEx/FedExRegistration';

export class FedExRegistrationService {
    static async getStatus(storeId: number): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.get<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}`,
        );
        return data;
    }

    static async completeFactor1(
        storeId: number,
        request: FedExFactor1Request,
    ): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.post<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}/factor1`,
            request,
        );
        return data;
    }

    static async requestPin(
        storeId: number,
        request: FedExRequestPinRequest,
    ): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.post<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}/factor2/request-pin`,
            request,
        );
        return data;
    }

    static async submitPin(
        storeId: number,
        request: FedExSubmitPinRequest,
    ): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.post<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}/factor2/submit-pin`,
            request,
        );
        return data;
    }

    static async submitInvoice(
        storeId: number,
        request: FedExSubmitInvoiceRequest,
    ): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.post<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}/factor2/submit-invoice`,
            request,
        );
        return data;
    }

    static async escalateToSupport(
        storeId: number,
        request: FedExEscalateSupportRequest,
    ): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.post<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}/factor2/escalate-support`,
            request,
        );
        return data;
    }

    static async rotateCredentials(
        storeId: number,
        request: FedExRotateCredentialsRequest,
    ): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.post<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}/rotate`,
            request,
        );
        return data;
    }

    static async offboard(storeId: number): Promise<FedExRegistrationStatusResponse> {
        const { data } = await axios.post<FedExRegistrationStatusResponse>(
            `/api/FedExRegistration/${storeId}/offboard`,
        );
        return data;
    }
}
